import { getTrackById } from '../../assets/asset_loaders/tracks';
import CupTrack from '../CupTrack';
import './HighwaysSidebar.css';

export default function HighwaysSidebar({ 
  selectedTrack, 
  highlightedConnectionId,
  onTrackHover,
  onTrackLeave,
  onTrackClick,
  onReset
}) {
  return (
    <div 
      className="highways-sidebar"
      data-has-selection={selectedTrack ? 'true' : undefined}
    >
      {selectedTrack && (
        <button 
          className="back-button" 
          onClick={onReset} 
          aria-label="Clear selection"
        >
          <span>✕</span>
        </button>
      )}
      
      <div id="trackimgs" className="track-images">
        {selectedTrack && <CupTrack start={selectedTrack?.id} />}

        {(highlightedConnectionId && highlightedConnectionId !== selectedTrack?.id) && (
          <>
            <p className="connection-arrow">»</p> 
            <CupTrack start={highlightedConnectionId} />
          </>
        )}
      </div>

      {selectedTrack ? (
        <div className="track-list-container">
          <ul>
            {selectedTrack?.connections.map((connectionId, index) => {
              const connectedTrack = getTrackById(connectionId);
              return (
                <li key={connectionId}>
                  <button
                    type="button"
                    className={`track-list-btn${highlightedConnectionId === connectionId ? ' highlighted' : ''}`}
                    onMouseEnter={() => onTrackHover(connectionId)}
                    onMouseLeave={onTrackLeave}
                    onClick={() => onTrackClick(connectionId)}
                  >
                    {`${index > 0 ? "» " : ""}${connectedTrack?.name}`}
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      ) : (
        <p>Click a track on the map to see its connections.</p>
      )}
    </div>
  );
}
